(() => {
  if (customElements.get('jonis-product-carousel')) return;
  class JonisProductCarousel extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      const sec = this;
      this.outer = this.querySelector('.jonis-carousel-outer');
      this.track = this.querySelector('.jonis-carousel-track');
      this.previous = this.querySelector('.jonis-carousel-btn--prev');
      this.next = this.querySelector('.jonis-carousel-btn--next');
      if (!this.outer || !this.track) return;
      this.previous.addEventListener('click', () => this.move(-1), { signal });
      this.next.addEventListener('click', () => this.move(1), { signal });
      this.outer.addEventListener('scroll', () => this.updateButtons(), { passive: true, signal });
      this.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.move(event.key === 'ArrowLeft' ? 1 : -1);
      }, { signal });
      this.resizeObserver = new ResizeObserver(() => this.updateButtons());
      this.resizeObserver.observe(this.outer);
      this.updateButtons();
  // Add to cart — רק לכפתורים אמיתיים. קישור לעמוד המוצר פשוט מנווט.
  sec.querySelectorAll('button.jonis-upsell-atc').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var vid = parseInt(btn.dataset.variantId, 10);
      if (!vid) return;
      var orig = btn.textContent;
      btn.classList.add('is-loading');
      btn.disabled = true;
      btn.textContent = '...';
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
      })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status >= 400) throw new Error(res.description || 'שגיאה');
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = '✓ נוסף לסל';
        return fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'include' });
      })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var p = new DOMParser();
        ['cart-icon-bubble', 'cart-drawer'].forEach(function (id) {
          if (!sections[id]) return;
          var d = p.parseFromString(sections[id], 'text/html');
          var s = d.getElementById('shopify-section-' + id) || d.querySelector('cart-drawer');
          var t = document.getElementById('shopify-section-' + id) || document.querySelector('cart-drawer');
          if (s && t) t.innerHTML = s.innerHTML;
        });
        var cd = document.querySelector('cart-drawer');
        if (cd && typeof cd.open === 'function') cd.open();
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = orig;
          btn.disabled = false;
        }, 2200);
      })
      .catch(function (err) {
        console.error(err);
        btn.classList.remove('is-loading');
        btn.textContent = orig;
        btn.disabled = false;
      });
    }, { signal });
  });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = null;
    }
    updateButtons() {
      this.track.classList.toggle('jonis-carousel-track--static', this.outer.scrollWidth - this.outer.clientWidth <= 1);
      const max = this.outer.scrollWidth - this.outer.clientWidth;
      const position = Math.abs(this.outer.scrollLeft);
      const loop = this.dataset.loop === 'true';
      this.previous.disabled = max <= 1 || (!loop && position <= 3);
      this.next.disabled = max <= 1 || (!loop && position >= max - 3);
    }
    move(direction) {
      const card = this.track.querySelector('.jonis-carousel-item');
      if (!card) return;
      const step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
      const max = Math.max(0, this.outer.scrollWidth - this.outer.clientWidth);
      if (max <= 1) return;
      const position = Math.abs(this.outer.scrollLeft);
      let target = Math.max(0, Math.min(position + direction * step, max));
      if (this.dataset.loop === 'true') {
        if (direction < 0 && position <= 3) target = max;
        if (direction > 0 && position >= max - 3) target = 0;
      }
      this.outer.scrollTo({ left: -target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
  }
  customElements.define('jonis-product-carousel', JonisProductCarousel);
})();
